import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { fetchArtists } from "../lib/api";
import { langField } from "../lib/i18n";

export default function Artists() {
  const { t, lang } = useApp();
  const [artists, setArtists] = useState([]);

  useEffect(() => {
    fetchArtists().then(setArtists);
  }, []);

  return (
    <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-12 md:py-20" data-testid="page-artists">
      <p className="font-mono text-xs tracking-[0.3em] text-kult-yellow">/ ROSTER</p>
      <h1 className="font-display text-6xl md:text-8xl mt-2 mb-3 leading-none">
        {t.artists.title}
      </h1>
      <p className="text-kult-muted max-w-xl mb-10">{t.artists.sub}</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-testid="artists-grid">
        {artists.map((a, i) => (
          <Link
            key={a.id}
            to={`/artists/${a.slug}`}
            className={`group border border-kult-border bg-kult-black2 hover:border-kult-pink transition-colors block ${
              i % 3 === 0 ? "md:col-span-2" : ""
            }`}
            data-testid={`artist-card-${a.slug}`}
          >
            <div
              className={`relative overflow-hidden ${
                i % 3 === 0 ? "aspect-[16/9]" : "aspect-[4/5]"
              } bg-black`}
            >
              <img
                src={a.image}
                alt={a.name}
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5">
                <p className="font-mono text-[10px] tracking-[0.3em] text-kult-yellow">
                  {langField(a, "role", lang).toUpperCase()}
                </p>
                <h3 className="font-display text-5xl md:text-7xl text-white group-hover:text-kult-pink transition-colors leading-none mt-2">
                  {a.name}
                </h3>
              </div>
            </div>
            <div className="p-6">
              <p className="text-kult-muted leading-relaxed">{langField(a, "bio", lang)}</p>
              {a.quote && (
                <p className="mt-4 font-display text-2xl text-kult-pink">
                  "{langField(a, "quote", lang)}"
                </p>
              )}
              <p className="mt-4 font-mono text-xs tracking-[0.25em] kult-link inline-block">
                VIEW {a.name} →
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
